// extracted by mini-css-extract-plugin
module.exports = {"alignmentToolStylesAlignmentTool":"theme_alignmentToolStylesAlignmentTool__1UfQm","buttonStyles":"theme_buttonStyles__2gqsI"};